import { useContext } from 'react';
import { LagoonContext } from '../LagoonContext';

export const useLagoon = () => {
  const lagoonTable = useContext(LagoonContext);

  // ## Tables

  // feature-flags
  const featureToggles = featureFlagKey => {
    if (lagoonTable?.featureToogles?.[featureFlagKey]) {
      return lagoonTable.featureToogles[featureFlagKey].active;
    }
    return false;
  };

  // error-messages
  const errorMessages = featureFlagKey => {
    if (lagoonTable?.errorMessages?.[featureFlagKey]) {
      return lagoonTable.errorMessages[featureFlagKey].message;
    }
    return false;
  };

  // ui-messages
  const uiMessages = featureFlagKey => {
    if (lagoonTable?.uiMessages?.[featureFlagKey]) {
      return lagoonTable.uiMessages[featureFlagKey].message;
    }
    return false;
  };

  return {
    featureToggles,
    errorMessages,
    uiMessages,
  };
};
